export default __webpack_public_path__ + "static/media/tink.5b878d5d.wav";